import jsPDF from "jspdf";
import "jspdf-autotable";
import config from "../common/Config";
import { axiosFetchProformaInvoice } from '../../utils/proformaInvoiceApi';

const generateUniqueFilename = (baseName, extension) => {
  const timestamp = new Date().toISOString().replace(/[-:.]/g, "");
  return `${baseName}_${timestamp}.${extension}`;
};

const generateSummaryPDF_rhv = async (orderId) => {
  const token = localStorage.getItem('token');
  const accessToken = localStorage.getItem("accessToken");
  const company_tax_type = localStorage.getItem("company_tax_type");

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  try {
    const data = await axiosFetchProformaInvoice(orderId, token);
    console.log(data);

    if (
      !data.success ||
      !data.details.orderDetails ||
      data.details.orderDetails.length === 0
    ) {
      console.error("No order details found in the response.");
      return;
    }

    const orderDetails = data.details.orderDetails[0];
    const shopDetails = data.details.shop_details;
    const invoiceType = data.details.invoice_type;
    const deliveryDetails = data.details.delivery_details;
    console.log(orderDetails);

    // Check state for tax logic
    const isMaharashtra =
      orderDetails.state &&
      orderDetails.state.toLowerCase().includes("maharashtra");
    const isGujarat =
      orderDetails.state &&
      orderDetails.state.toLowerCase().includes("gujarat");

    const totalstd = data.details.product_details
      .filter((item) => item.item_tax != "0.00" && item.item_tax != null)
      .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

    const box_qty = data.details.product_details
      .filter(
        (item) =>
          item.quantity != "0.00" &&
          item.quantity != null &&
          item.order_type === "box"
      )
      .reduce((sum, item) => sum + parseFloat(item.quantity), 0);

    const piece_qty = data.details.product_details
      .filter(
        (item) =>
          item.quantity != "0.00" &&
          item.quantity != null &&
          item.order_type === "piece"
      )
      .reduce((sum, item) => sum + parseFloat(item.quantity), 0);

    const totalzeroGoods = data.details.product_details
      .filter((item) => item.item_tax == "0.00" || item.item_tax === null)
      .reduce((sum, item) => sum + parseFloat(item.subtotal), 0);

    const totalSTDGoods = parseFloat(totalstd);
    const orderDiscount =
      parseFloat(data.details.orderDetails[0].order_discount) || 0;
    const orderDiscount1 =
      parseFloat(data.details.orderDetails[0].order_discount) || 0;
    const orderDiscount2 =
      parseFloat(data.details.orderDetails[0].over_all_discount) || 0;
    let orderDiscount3 =
      ((totalstd + totalzeroGoods) *
        parseFloat(data.details.orderDetails[0].over_all_discount)) /
        100 || 0;

    let totalVAT = data.details.product_details
      .filter((item) => item.item_tax !== "0.00" || item.item_tax !== null)
      .reduce((sum, item) => sum + (parseFloat(item.item_tax) || 0), 0);

    let totalDiscountOnVat = 0;
    if (parseFloat(data.details.orderDetails[0].over_all_discount) > 0) {
      totalDiscountOnVat += parseFloat(
        data.details.orderDetails[0].over_all_discount
      );
    }

    if (data.details.orderDetails[0].percentage !== null) {
      totalDiscountOnVat += parseFloat(data.details.orderDetails[0].percentage);
    }

    const itemTotal = totalstd + totalzeroGoods;
    totalVAT = totalVAT - (totalVAT * totalDiscountOnVat) / 100;
    let over_all_amount =
      ((totalstd + totalzeroGoods) *
        parseFloat(data.details.orderDetails[0].over_all_discount)) /
      100;

    // Calculate CGST/SGST, IGST, and CESS based on state and product-specific rates
    let cgstAmount = 0;
    let sgstAmount = 0;
    let igstAmount = 0;
    let cessAmount = 0;

    // Calculate product-wise tax amounts
    if (isMaharashtra) {
      // For Maharashtra: Split total tax into CGST and SGST (usually 50-50)
      cgstAmount = totalVAT / 2;
      sgstAmount = totalVAT / 2;
    } else if (isGujarat) {
      // For Gujarat: CGST + SGST + CESS
      cgstAmount = totalVAT / 2;
      sgstAmount = totalVAT / 2;
      // Calculate CESS amount based on product-wise rates
      cessAmount = data.details.product_details
        .filter(item => item.item_tax !== "0.00" && item.item_tax !== null)
        .reduce((sum, item) => {
          const itemSubtotal = parseFloat(item.subtotal) || 0;
          const itemCessRate = parseFloat(item.cess_rate_percent) || 0;
          return sum + ((itemSubtotal * itemCessRate) / 100);
        }, 0);
    } else {
      // For other states: Use IGST
      igstAmount = totalVAT;
    }

    // Calculate total amount including CESS for Gujarat
    let totalAmount =
      totalstd +
      totalzeroGoods +
      totalVAT -
      parseFloat(data.details.orderDetails[0].order_discount) -
      over_all_amount;

    if (isGujarat) {
      totalAmount += cessAmount; // Add CESS to total for Gujarat
    }

    const addRibbonTitle = (
      doc,
      title,
      fontSize,
      pageWidth,
      margin,
      topMargin
    ) => {
      doc.setFont("helvetica", "bold");
      doc.setFontSize(fontSize);
      doc.setTextColor(0, 0, 0);
      const titleWidth = doc.getTextWidth(title);
      const titleX = pageWidth - titleWidth - margin;
      const titleY = topMargin + fontSize;
      doc.text(title, titleX, titleY);
    };

    const doc = new jsPDF("portrait");
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 5;
    let y = margin-5;
    const firstColumnWidth = pageWidth * 0.25;
    const secondColumnWidth = pageWidth * 0.75;
    const H2firstColumnWidth = pageWidth * 0.4;
    const H2secondColumnWidth = pageWidth * 0.25;
    const H2thirdColumnWidth = pageWidth * 0.25;

    // Add the logo image to the header
    const logoUrl = `${config.BASE_URL}/assets/img/${accessToken}_logo.png`;
    const logoWidth = 38;
    const logoHeight = 38;
    doc.addImage(logoUrl, "PNG", margin + 5, y, logoWidth, logoHeight);
    //y += logoHeight + 5;

    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    const title = ``;
    const fontSize = 10;
    const topMargin = 3;
    addRibbonTitle(doc, title, fontSize, pageWidth, margin, topMargin);
    y += 10;

    const headerSections2 = [
      [],
      [
        { text: `${shopDetails.shop_name}`, size: 13, bold: true },
        { text: `${shopDetails.address.split(",")[0]}`, size: 8, bold: false },
        { text: `${shopDetails.address.split(",")[1]}`, size: 8, bold: false },
        {
          text: `Company No : ${shopDetails.company_reg_no} | ${company_tax_type} No : ${shopDetails.vat_no}`,
          size: 8,
          bold: false,
        },
        {
          text: `Phone No : ${shopDetails.phone} | Email : ${shopDetails.email}`,
          size: 8,
          bold: false,
        },
        {
          text: `Website : ${shopDetails.website} `,
          size: 8,
          bold: false,
        },
      ],
    ];

    const headerSections3 = [
      [
        { text: `Customer Details`, size: 8, bold: true },
        { text: `${orderDetails.company}`, size: 8, bold: true },

        // Dynamic 3-line address split
        ...(() => {
          const parts = orderDetails.address.split(",").map((p) => p.trim());
          const chunkSize = Math.ceil(parts.length / 3);
          return [
            {
              text: parts.slice(0, chunkSize).join(", "),
              size: 8,
              bold: false,
            },
            {
              text: parts.slice(chunkSize, chunkSize * 2).join(", "),
              size: 8,
              bold: false,
            },
            {
              text: parts.slice(chunkSize * 2).join(", "),
              size: 8,
              bold: false,
            },
          ];
        })(),

        { text: `${orderDetails.state}`, size: 8, bold: false },
        { text: `${orderDetails.postal_code}`, size: 8, bold: false },
        {
          text: `Phone No : ${orderDetails.phone} | Email : ${orderDetails.email}`,
          size: 8,
          bold: false,
        },
        { text: `GST No : ${orderDetails.gst_no}`, size: 8, bold: false },
      ],

      [
        {
          text: `Invoice No : ${orderDetails.reference_no}`,
          size: 8,
          bold: false,
        },
        {
          text: `Invoice Date: ${orderDetails.invoice_date}`,
          size: 8,
          bold: false,
        },
        { text: `A/C No: ${orderDetails.account_no}`, size: 8, bold: false },
        {
          text: `Route No : ${orderDetails.route_number}`,
          size: 8,
          bold: false,
        },
        { text: `Order By: ${orderDetails.orderby}`, size: 8, bold: false },
      ],
      [
        { text: `Bank Details`, size: 8, bold: true },
        { text: `${shopDetails.shop_name}`, size: 8, bold: true },
        { text: ``, size: 8, bold: false },
        { text: `A/C No : ${shopDetails.bank_ac}`, size: 8, bold: false },
        { text: `Sort Code: ${shopDetails.sort_code}`, size: 8, bold: false },
      ],
    ];

    const sectionWidth = (pageWidth - margin * 2) / 3;

    // Render header sections
    y = 5;
    const renderSections = (sections, marginTop = 7) => {
      let yPosition = y + marginTop;
      sections.forEach((section, index) => {
        const colStartX = margin + (index % 3) * firstColumnWidth;
        section.forEach((item, i) => {
          doc.setFontSize(item.size);
          doc.setFont(
            item.bold ? "helvetica" : "helvetica",
            item.bold ? "bold" : "normal"
          );
          doc.text(item.text, colStartX, yPosition + i * 4);
        });
        if (index % 4 === 3) {
          yPosition += 12;
        }
      });
      yPosition += 25;
      y = yPosition;
    };

    renderSections(headerSections2);

    const h2renderSections = (sections) => {
      let rowHeight = 0;
      let rowStartY = y;
      let columnHeights = [];

      sections.forEach((section, index) => {
        let colStartX;
        if (index % 3 === 0) {
          colStartX = margin - 1;
        } else if (index % 3 === 1) {
          colStartX = margin + H2firstColumnWidth + 2;
        } else {
          colStartX = margin + H2firstColumnWidth + H2secondColumnWidth + 5;
        }

        let sectionHeight = 0;

        section.forEach((item, i) => {
          doc.setFontSize(item.size);
          doc.setFont(
            item.bold ? "helvetica" : "helvetica",
            item.bold ? "bold" : "normal"
          );

          let maxWidth;
          if (index % 3 === 0) {
            maxWidth = H2firstColumnWidth + 5;
          } else if (index % 3 === 1) {
            maxWidth = H2secondColumnWidth + 4;
          } else {
            maxWidth = H2thirdColumnWidth + 5;
          }

          const textWidth = doc.getTextWidth(item.text);
          let lines = [];
          if (textWidth > maxWidth) {
            let words = item.text.split(" ");
            let line = "";
            words.forEach((word) => {
              const testLine = line + (line ? " " : "") + word;
              if (doc.getTextWidth(testLine) <= maxWidth) {
                line = testLine;
              } else {
                lines.push(line);
                line = word;
              }
            });
            lines.push(line);
          } else {
            lines.push(item.text);
          }

          lines.forEach((lineText, lineIndex) => {
            const lineHeight = 4;
            doc.text(
              lineText,
              colStartX + 5,
              y + 5 + i * lineHeight + lineIndex * lineHeight
            );
            sectionHeight = y + i + lineIndex - 5;
          });
        });

        columnHeights.push(sectionHeight);

        if ((index + 1) % 3 === 0) {
          rowHeight = Math.max(...columnHeights);
          columnHeights = [];

          let colX = margin;
          for (let i = 0; i < 3; i++) {
            doc.setLineWidth(0.1);
            let colWidth =
              i === 0
                ? H2firstColumnWidth
                : i === 1
                ? H2secondColumnWidth
                : H2thirdColumnWidth;
            doc.rect(colX-2, rowStartY - 0, colWidth + 4, rowHeight + 3);
            colX += colWidth + 4;
          }
          y += rowHeight + 12;
        }
      });
      y += -3;
    };

    h2renderSections(headerSections3);

    // Table columns with state-specific tax columns
    const tableColumns = [
      {
        title: "HSN Code - Product",
        dataKey: "product",
        size: 8,
        bold: true,
        halign: "center",
      },
      {
        title: "Type",
        dataKey: "order_type",
        size: 8,
        bold: true,
        halign: "center",
      },
      { title: "Qty", dataKey: "qty", size: 8, bold: true, halign: "center" },
      {
        title: "Price",
        dataKey: "unit_price",
        size: 8,
        bold: true,
        halign: "center",
      },
      {
        title: "Disc",
        dataKey: "discount",
        size: 8,
        bold: true,
        halign: "center",
      },
    ];

    // Add tax columns based on state
    if (isMaharashtra) {
      tableColumns.push(
        {
          title: "CGST %",
          dataKey: "cgst_percent",
          size: 8,
          bold: true,
          halign: "center",
        },
        {
          title: "CGST Amt",
          dataKey: "cgst_amount",
          size: 8,
          bold: true,
          halign: "center",
        },
        {
          title: "SGST %",
          dataKey: "sgst_percent",
          size: 8,
          bold: true,
          halign: "center",
        },
        {
          title: "SGST Amt",
          dataKey: "sgst_amount",
          size: 8,
          bold: true,
          halign: "center",
        }
      );
    } else if (isGujarat) {
      // Gujarat: CGST + SGST + CESS columns
      tableColumns.push(
        {
          title: "CGST %",
          dataKey: "cgst_percent",
          size: 8,
          bold: true,
          halign: "center",
        },
        {
          title: "CGST Amt",
          dataKey: "cgst_amount",
          size: 8,
          bold: true,
          halign: "center",
        },
        {
          title: "SGST %",
          dataKey: "sgst_percent",
          size: 8,
          bold: true,
          halign: "center",
        },
        {
          title: "SGST Amt",
          dataKey: "sgst_amount",
          size: 8,
          bold: true,
          halign: "center",
        },
        {
          title: "CESS %",
          dataKey: "cess_percent",
          size: 8,
          bold: true,
          halign: "center",
        },
        {
          title: "CESS Amt",
          dataKey: "cess_amount",
          size: 8,
          bold: true,
          halign: "center",
        }
      );
    } else {
      tableColumns.push(
        {
          title: "IGST %",
          dataKey: "igst_percent",
          size: 8,
          bold: true,
          halign: "center",
        },
        {
          title: "IGST Amt",
          dataKey: "igst_amount",
          size: 8,
          bold: true,
          halign: "center",
        }
      );
    }

    tableColumns.push({
      title: "Total",
      dataKey: "net_amount",
      size: 8,
      bold: true,
      halign: "center",
    });

    // Calculate column widths based on state
    const totalWidth = pageWidth - 2 * margin;
    let productWidth, orderTypeWidth, qtyWidth, unitPriceWidth, discountWidth, 
        taxPercentWidth, taxAmountWidth, netAmountWidth;

    if (isMaharashtra) {
      // Maharashtra: CGST + SGST (4 tax columns)
      productWidth = totalWidth * 0.35;
      orderTypeWidth = totalWidth * 0.05;
      qtyWidth = totalWidth * 0.05;
      unitPriceWidth = totalWidth * 0.08;
      discountWidth = totalWidth * 0.06;
      taxPercentWidth = totalWidth * 0.06;
      taxAmountWidth = totalWidth * 0.08;
      netAmountWidth = totalWidth * 0.1;
    } else if (isGujarat) {
      // Gujarat: CGST + SGST + CESS (6 tax columns) - need to reduce other column widths
      productWidth = totalWidth * 0.30; // Reduced to accommodate CESS columns
      orderTypeWidth = totalWidth * 0.05;
      qtyWidth = totalWidth * 0.05;
      unitPriceWidth = totalWidth * 0.07;
      discountWidth = totalWidth * 0.07;
      taxPercentWidth = totalWidth * 0.07; // Smaller for 6 tax columns
      taxAmountWidth = totalWidth * 0.07;
      netAmountWidth = totalWidth * 0.07;
    } else {
      // Other states: IGST only (2 tax columns)
      productWidth = totalWidth * 0.47;
      orderTypeWidth = totalWidth * 0.05;
      qtyWidth = totalWidth * 0.05;
      unitPriceWidth = totalWidth * 0.1;
      discountWidth = totalWidth * 0.07;
      taxPercentWidth = totalWidth * 0.06;
      taxAmountWidth = totalWidth * 0.1;
      netAmountWidth = totalWidth * 0.1;
    }

    // Construct table body with state-specific tax columns
    const tableBody = data.details.product_details.map((item) => {
      const hsn = item.hsn_code && item.hsn_code.trim() !== '' ? item.hsn_code : 'N/A';
      const baseRow = [
        hsn +
          " - " +
          item.product_name +
          " - " +
          item.size +
          item.promo_product +
          item.free_product,
        item.order_type,
        parseInt(item.quantity),
        "" + item.unit_price,
        item.item_discount,
      ];

      // Add tax columns based on state
      if (isMaharashtra) {
        const itemTax = parseFloat(item.item_tax) || 0;
        const itemTaxRate = parseFloat(item.tax_rate_percent) || 0;
        const cgstAmt = (itemTax / 2).toFixed(2);
        const sgstAmt = (itemTax / 2).toFixed(2);
        const cgstRate = (itemTaxRate / 2).toFixed(0);
        const sgstRate = (itemTaxRate / 2).toFixed(0);

        baseRow.push(
          `${cgstRate}%`, // CGST %
          cgstAmt,        // CGST Amount
          `${sgstRate}%`, // SGST %
          sgstAmt         // SGST Amount
        );
      } else if (isGujarat) {
        const itemTax = parseFloat(item.item_tax) || 0;
        const itemTaxRate = parseFloat(item.tax_rate_percent) || 0;
        const itemCessRate = parseFloat(item.cess_rate_percent) || 0;
        const cgstAmt = (itemTax / 2).toFixed(2);
        const sgstAmt = (itemTax / 2).toFixed(2);
        const cgstRate = (itemTaxRate / 2).toFixed(2);
        const sgstRate = (itemTaxRate / 2).toFixed(2);
        // Calculate item-level CESS
        const itemSubtotal = parseFloat(item.subtotal) || 0;
        const itemCessAmt = ((itemSubtotal * itemCessRate) / 100).toFixed(2);

        baseRow.push(
          `${cgstRate}%`,  // CGST %
          cgstAmt,         // CGST Amount
          `${sgstRate}%`,  // SGST %
          sgstAmt,         // SGST Amount
          `${itemCessRate}%`,  // CESS %
          itemCessAmt      // CESS Amount
        );
        
      } else {
        const itemTaxRate = parseFloat(item.tax_rate_percent) || 0;
        baseRow.push(
          `${itemTaxRate}%`,   // IGST %
          item.item_tax    // IGST Amount
        );
      }

      baseRow.push("" + item.subtotal);
      return baseRow;
    });

    // Add total rows with correct column spans
    const totalColSpan = isMaharashtra ? 9 : (isGujarat ? 11 : 7);

    tableBody.push([
      {
        content: "Item Total:",
        colSpan: totalColSpan,
        styles: { halign: "right" },
      },
      { content: `${itemTotal.toFixed(2)}` },
    ]);

    // Calculate average tax rates for summary
    const taxableProducts = data.details.product_details.filter(
      item => item.item_tax !== "0.00" && item.item_tax !== null
    );
    
    const avgTaxRate = taxableProducts.length > 0 
      ? taxableProducts.reduce((sum, item) => sum + parseFloat(item.tax_rate_percent || 0), 0) / taxableProducts.length
      : 0;
    
    const avgCessRate = isGujarat && taxableProducts.length > 0
      ? taxableProducts.reduce((sum, item) => sum + parseFloat(item.cess_rate_percent || 0), 0) / taxableProducts.length
      : 0;

    // Tax summary row with state-specific columns
    if (isMaharashtra) {
      tableBody.push([
        {
          content: `Total Zero Goods - ${totalzeroGoods.toFixed(
            2
          )} | Total Std Goods - ${totalstd.toFixed(2)}`,
          colSpan: 5,
          styles: { halign: "left" },
        },
        {
          content: `${(avgTaxRate / 2).toFixed(2)}%`,
          styles: { halign: "center", fontSize: 8, fontStyle: "bold" },
        },
        {
          content: `${cgstAmount.toFixed(2)}`,
          styles: { halign: "right", fontSize: 8, fontStyle: "bold" },
        },
        {
          content: `${(avgTaxRate / 2).toFixed(2)}%`,
          styles: { halign: "center", fontSize: 8, fontStyle: "bold" },
        },
        {
          content: `${sgstAmount.toFixed(2)}`,
          styles: { halign: "right", fontSize: 8, fontStyle: "bold" },
        },
        { content: `${totalVAT.toFixed(2)}` },
      ]);
    } else if (isGujarat) {
      tableBody.push([
        {
          content: `Total Zero Goods - ${totalzeroGoods.toFixed(
            2
          )} | Total Std Goods - ${totalstd.toFixed(2)}`,
          colSpan: 5,
          styles: { halign: "left" },
        },
        {
          content: `${(avgTaxRate).toFixed(2)}%`,
          styles: { halign: "center", fontSize: 8, fontStyle: "bold" },
        },
        {
          content: `${cgstAmount.toFixed(2)}`,
          styles: { halign: "right", fontSize: 8, fontStyle: "bold" },
        },
        {
          content: `${(avgTaxRate / 2).toFixed(2)}%`,
          styles: { halign: "center", fontSize: 8, fontStyle: "bold" },
        },
        {
          content: `${sgstAmount.toFixed(2)}`,
          styles: { halign: "right", fontSize: 8, fontStyle: "bold" },
        },
        {
          content: `-`,
          styles: { halign: "center", fontSize: 8, fontStyle: "bold" },
        },
        {
          content: `${cessAmount.toFixed(2)}`,
          styles: { halign: "right", fontSize: 8, fontStyle: "bold" },
        },
        { content: `${(totalVAT + cessAmount).toFixed(2)}` },
      ]);
    } else {
      tableBody.push([
        {
          content: `Total Zero Goods - ${totalzeroGoods.toFixed(
            2
          )} | Total Std Goods - ${totalstd.toFixed(2)}`,
          colSpan: 5,
          styles: { halign: "left" },
        },
        {
          content: `${avgTaxRate.toFixed(2)}%`,
          styles: { halign: "center", fontSize: 8, fontStyle: "bold" },
        },
        {
          content: `${igstAmount.toFixed(2)}`,
          styles: { halign: "right", fontSize: 8, fontStyle: "bold" },
        },
        { content: `${totalVAT.toFixed(2)}` },
      ]);
    }

    if (orderDiscount2 != 0 && orderDiscount2 !== "") {
      tableBody.push([
        {
          content: `Order Discount (${orderDiscount2}%):`,
          colSpan: totalColSpan,
          styles: { halign: "right", fontSize: 8, fontStyle: "bold" },
        },
        orderDiscount3.toFixed(2),
      ]);
    }

    if (orderDiscount1 != 0 && orderDiscount1 !== "") {
      tableBody.push([
        {
          content: `Promo Discount :`,
          colSpan: totalColSpan,
          styles: { halign: "right", fontSize: 8, fontStyle: "bold" },
        },
        orderDiscount.toFixed(2),
      ]);
    }

    tableBody.push([
      {
        content: `Box : ${box_qty} PCs : ${piece_qty} `,
        colSpan: totalColSpan - 1,
        styles: { halign: "left" },
      },
      {
        content: "Invoice Total:",
        styles: { halign: "right", fontSize: 8, fontStyle: "bold" },
      },
      { content: `${totalAmount.toFixed(2)}` },
    ]);

    // Column styles configuration based on state
    const columnStyles = {
      0: { cellWidth: productWidth, fontSize: 8, fontStyle: "bold" },
      1: {
        cellWidth: orderTypeWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "center",
      },
      2: {
        cellWidth: qtyWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "center",
      },
      3: {
        cellWidth: unitPriceWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "right",
      },
      4: {
        cellWidth: discountWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "center",
      },
    };

    if (isMaharashtra) {
      columnStyles[5] = {
        cellWidth: taxPercentWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "center",
      }; // CGST %
      columnStyles[6] = {
        cellWidth: taxAmountWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "right",
      }; // CGST Amt
      columnStyles[7] = {
        cellWidth: taxPercentWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "center",
      }; // SGST %
      columnStyles[8] = {
        cellWidth: taxAmountWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "right",
      }; // SGST Amt
      columnStyles[9] = {
        cellWidth: netAmountWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "right",
      }; // Total
    } else if (isGujarat) {
      columnStyles[5] = {
        cellWidth: taxPercentWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "center",
      }; // CGST %
      columnStyles[6] = {
        cellWidth: taxAmountWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "right",
      }; // CGST Amt
      columnStyles[7] = {
        cellWidth: taxPercentWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "center",
      }; // SGST %
      columnStyles[8] = {
        cellWidth: taxAmountWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "right",
      }; // SGST Amt
      columnStyles[9] = {
        cellWidth: taxPercentWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "center",
      }; // CESS %
      columnStyles[10] = {
        cellWidth: taxAmountWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "right",
      }; // CESS Amt
      columnStyles[11] = {
        cellWidth: netAmountWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "right",
      }; // Total
    } else {
      columnStyles[5] = {
        cellWidth: taxPercentWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "center",
      }; // IGST %
      columnStyles[6] = {
        cellWidth: taxAmountWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "right",
      }; // IGST Amt
      columnStyles[7] = {
        cellWidth: netAmountWidth,
        fontSize: 8,
        fontStyle: "bold",
        halign: "right",
      }; // Total
    }

    doc.autoTable({
      startY: y,
      head: [tableColumns.map((col) => col.title)],
      body: tableBody,
      theme: "grid",
      headStyles: {
        fillColor: "#f8f9fa",
        textColor: "#404040",
        fontSize: 8,
        valign: "middle",
        lineWidth: 0.3,
        halign: "center",
        lineColor: [0, 0, 0],
      },
      bodyStyles: {
        fontSize: 8,
        valign: "middle",
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
      },
      margin: { top: 0, left: margin-2.5, right: margin + 90 },
      columnStyles: columnStyles,
    });

    // Update y position after main table
    y = doc.autoTable.previous.finalY - 5;

    // Check if we need to add a new page before HSN summary
    const remainingSpace = pageHeight - y - margin;
    const estimatedHSNTableHeight = Object.keys(data.details.product_details).length * 8 + 30; // Rough estimate
    
    if (remainingSpace < estimatedHSNTableHeight) {
      doc.addPage();
      y = margin + 10;
    }

    // Build HSN summary data
    const summaryByHSN = {};

    data.details.product_details.forEach(item => {
      const hsn = item.hsn_code || 'N/A';
      const quantity = parseFloat(item.quantity || 0);
      const subtotal = parseFloat(item.subtotal || 0);
      const tax = parseFloat(item.item_tax || 0);
      const taxRate = parseFloat(item.tax_rate_percent || 0);
      const cessRate = parseFloat(item.cess_rate_percent || 0);
      
      const cgst = isMaharashtra || isGujarat ? tax / 2 : 0;
      const sgst = isMaharashtra || isGujarat ? tax / 2 : 0;
      const igst = (!isMaharashtra && !isGujarat) ? tax : 0;
      const cess = isGujarat ? (subtotal * cessRate) / 100 : 0;
  
      if (!summaryByHSN[hsn]) {
        summaryByHSN[hsn] = { 
          quantity: 0, 
          taxable: 0, 
          cgstRate: taxRate / 2, 
          cgst: 0, 
          sgstRate: taxRate / 2, 
          sgst: 0,
          igstRate: taxRate,
          igst: 0,
          cessRate: cessRate,
          cess: 0, 
          total: 0 
        };
      }
  
      summaryByHSN[hsn].quantity += quantity;
      summaryByHSN[hsn].taxable += subtotal;
      summaryByHSN[hsn].cgst += cgst;
      summaryByHSN[hsn].sgst += sgst;
      summaryByHSN[hsn].igst += igst;
      summaryByHSN[hsn].cess += cess;
      summaryByHSN[hsn].total += subtotal + tax + cess;
    });

    // Build HSN summary table structure based on state
    let hsnHeaders, hsnRows;
    
    if (isMaharashtra) {
      // Maharashtra: HSN Code | Qty | Taxable Amount | CGST Rate | CGST Amount | SGST Rate | SGST Amount | Total Amount
      hsnHeaders = [
        "HSN Code", 
        "Qty", 
        "Taxable\nAmount", 
        "CGST\nRate", 
        "CGST\nAmount", 
        "SGST\nRate", 
        "SGST\nAmount", 
        "Total\nAmount"
      ];
      
      hsnRows = Object.entries(summaryByHSN).map(([hsn, vals]) => [
        hsn,
        vals.quantity.toFixed(0),
        vals.taxable.toFixed(2),
        vals.cgstRate.toFixed(2) + '%',
        vals.cgst.toFixed(0),
        vals.sgstRate.toFixed(2) + '%',
        vals.sgst.toFixed(2),
        vals.total.toFixed(2)
      ]);
      
    } else if (isGujarat) {
      // Gujarat: HSN Code | Qty | Taxable Amount | CGST Rate | CGST Amount | SGST Rate | SGST Amount | CESS Rate | CESS Amount | Total Amount
      hsnHeaders = [
        "HSN Code", 
        "Qty", 
        "Taxable\nAmount", 
        "CGST\nRate", 
        "CGST\nAmount", 
        "SGST\nRate", 
        "SGST\nAmount", 
        "CESS\nRate", 
        "CESS\nAmount", 
        "Total\nAmount"
      ];
      
      hsnRows = Object.entries(summaryByHSN).map(([hsn, vals]) => [
        hsn,
        vals.quantity.toFixed(0),
        vals.taxable.toFixed(2),
        vals.cgstRate.toFixed(2) + '%',
        vals.cgst.toFixed(2),
        vals.sgstRate.toFixed(2) + '%',
        vals.sgst.toFixed(2),
        vals.cessRate.toFixed(2) + '%',
        vals.cess.toFixed(2),
        vals.total.toFixed(2)
      ]);
      
    } else {
      // Other states: HSN Code | Qty | Taxable Amount | IGST Rate | IGST Amount | Total Amount
      hsnHeaders = [
        "HSN Code", 
        "Qty", 
        "Taxable\nAmount", 
        "IGST\nRate", 
        "IGST\nAmount", 
        "Total\nAmount"
      ];
      
      hsnRows = Object.entries(summaryByHSN).map(([hsn, vals]) => [
        hsn,
        vals.quantity.toFixed(0),
        vals.taxable.toFixed(2),
        vals.igstRate.toFixed(2) + '%',
        vals.igst.toFixed(2),
        vals.total.toFixed(2)
      ]);
    }

    // Add Grand Total row
    const grandTotalQty = Object.values(summaryByHSN).reduce((sum, vals) => sum + vals.quantity, 0);
    const grandTotalTaxable = Object.values(summaryByHSN).reduce((sum, vals) => sum + vals.taxable, 0);
    const grandTotalAmount = Object.values(summaryByHSN).reduce((sum, vals) => sum + vals.total, 0);
    
    if (isMaharashtra) {
      const grandTotalCGST = Object.values(summaryByHSN).reduce((sum, vals) => sum + vals.cgst, 0);
      const grandTotalSGST = Object.values(summaryByHSN).reduce((sum, vals) => sum + vals.sgst, 0);
      
      hsnRows.push([
        { content: "Grand Total", styles: { fontStyle: "bold", halign: "center" } },
        { content: grandTotalQty.toFixed(0), styles: { fontStyle: "bold" } },
        { content: grandTotalTaxable.toFixed(2), styles: { fontStyle: "bold" } },
        { content: "", styles: { fontStyle: "bold" } },
        { content: grandTotalCGST.toFixed(2), styles: { fontStyle: "bold" } },
        { content: "", styles: { fontStyle: "bold" } },
        { content: grandTotalSGST.toFixed(2), styles: { fontStyle: "bold" } },
        { content: grandTotalAmount.toFixed(2), styles: { fontStyle: "bold" } }
      ]);
      
    } else if (isGujarat) {
      const grandTotalCGST = Object.values(summaryByHSN).reduce((sum, vals) => sum + vals.cgst, 0);
      const grandTotalSGST = Object.values(summaryByHSN).reduce((sum, vals) => sum + vals.sgst, 0);
      const grandTotalCESS = Object.values(summaryByHSN).reduce((sum, vals) => sum + vals.cess, 0);
      
      hsnRows.push([
        { content: "Grand Total", styles: { fontStyle: "bold", halign: "center" } },
        { content: grandTotalQty.toFixed(0), styles: { fontStyle: "bold" } },
        { content: grandTotalTaxable.toFixed(2), styles: { fontStyle: "bold" } },
        { content: "", styles: { fontStyle: "bold" } },
        { content: grandTotalCGST.toFixed(2), styles: { fontStyle: "bold" } },
        { content: "", styles: { fontStyle: "bold" } },
        { content: grandTotalSGST.toFixed(2), styles: { fontStyle: "bold" } },
        { content: "", styles: { fontStyle: "bold" } },
        { content: grandTotalCESS.toFixed(2), styles: { fontStyle: "bold" } },
        { content: grandTotalAmount.toFixed(2), styles: { fontStyle: "bold" } }
      ]);
      
    } else {
      const grandTotalIGST = Object.values(summaryByHSN).reduce((sum, vals) => sum + vals.igst, 0);
      
      hsnRows.push([
        { content: "Grand Total", styles: { fontStyle: "bold", halign: "center" } },
        { content: grandTotalQty.toFixed(0), styles: { fontStyle: "bold" } },
        { content: grandTotalTaxable.toFixed(2), styles: { fontStyle: "bold" } },
        { content: "", styles: { fontStyle: "bold" } },
        { content: grandTotalIGST.toFixed(2), styles: { fontStyle: "bold" } },
        { content: grandTotalAmount.toFixed(2), styles: { fontStyle: "bold" } }
      ]);
    }
  
    // Add HSN summary table header
    doc.setFont("helvetica", "bold");
    doc.setFontSize(10);
    // doc.text("HSN-Wise Summary", margin, y);
    y += 10;

    // Define column styles for HSN table based on state
    const hsnColumnStyles = {};
    const hsnTableWidth = pageWidth - 2 * margin;
    
    if (isMaharashtra) {
      // 8 columns for Maharashtra
      hsnColumnStyles[0] = { cellWidth: hsnTableWidth * 0.12, halign: "center",fontStyle: "bold", fontSize: 7 }; // HSN Code
      hsnColumnStyles[1] = { cellWidth: hsnTableWidth * 0.08, halign: "center",fontStyle: "bold", fontSize: 7 }; // Qty
      hsnColumnStyles[2] = { cellWidth: hsnTableWidth * 0.15, halign: "right",fontStyle: "bold", fontSize: 7 };  // Taxable Amount
      hsnColumnStyles[3] = { cellWidth: hsnTableWidth * 0.12, halign: "center",fontStyle: "bold", fontSize: 7 }; // CGST Rate
      hsnColumnStyles[4] = { cellWidth: hsnTableWidth * 0.13, halign: "right",fontStyle: "bold", fontSize: 7 };  // CGST Amount
      hsnColumnStyles[5] = { cellWidth: hsnTableWidth * 0.12, halign: "center",fontStyle: "bold", fontSize: 7 }; // SGST Rate
      hsnColumnStyles[6] = { cellWidth: hsnTableWidth * 0.13, halign: "right",fontStyle: "bold", fontSize: 7 };  // SGST Amount
      hsnColumnStyles[7] = { cellWidth: hsnTableWidth * 0.15, halign: "right",fontStyle: "bold", fontSize: 7 };  // Total Amount
    } else if (isGujarat) {
      // 10 columns for Gujarat
      hsnColumnStyles[0] = { cellWidth: hsnTableWidth * 0.10, halign: "center",fontStyle: "bold", fontSize: 7 }; // HSN Code
      hsnColumnStyles[1] = { cellWidth: hsnTableWidth * 0.07, halign: "center",fontStyle: "bold", fontSize: 7 }; // Qty
      hsnColumnStyles[2] = { cellWidth: hsnTableWidth * 0.12, halign: "right",fontStyle: "bold", fontSize: 7 };  // Taxable Amount
      hsnColumnStyles[3] = { cellWidth: hsnTableWidth * 0.09, halign: "center", fontStyle: "bold", fontSize: 7 }; // CGST Rate
      hsnColumnStyles[4] = { cellWidth: hsnTableWidth * 0.11, halign: "right",fontStyle: "bold", fontSize: 7 };  // CGST Amount
      hsnColumnStyles[5] = { cellWidth: hsnTableWidth * 0.09, halign: "center",fontStyle: "bold", fontSize: 7 }; // SGST Rate
      hsnColumnStyles[6] = { cellWidth: hsnTableWidth * 0.11, halign: "right",fontStyle: "bold", fontSize: 7 };  // SGST Amount
      hsnColumnStyles[7] = { cellWidth: hsnTableWidth * 0.09, halign: "center",fontStyle: "bold", fontSize: 7 }; // CESS Rate
      hsnColumnStyles[8] = { cellWidth: hsnTableWidth * 0.10, halign: "right",fontStyle: "bold", fontSize: 7 };  // CESS Amount
      hsnColumnStyles[9] = { cellWidth: hsnTableWidth * 0.12, halign: "right",fontStyle: "bold", fontSize: 7 };  // Total Amount
    } else {
      // 6 columns for other states
      hsnColumnStyles[0] = { cellWidth: hsnTableWidth * 0.15, halign: "center",fontStyle: "bold", fontSize: 7 }; // HSN Code
      hsnColumnStyles[1] = { cellWidth: hsnTableWidth * 0.10, halign: "center",fontStyle: "bold", fontSize: 7 }; // Qty
      hsnColumnStyles[2] = { cellWidth: hsnTableWidth * 0.20, halign: "right",fontStyle: "bold", fontSize: 7 };  // Taxable Amount
      hsnColumnStyles[3] = { cellWidth: hsnTableWidth * 0.15, halign: "center",fontStyle: "bold", fontSize: 7 }; // IGST Rate
      hsnColumnStyles[4] = { cellWidth: hsnTableWidth * 0.20, halign: "right",fontStyle: "bold", fontSize: 7 };  // IGST Amount
      hsnColumnStyles[5] = { cellWidth: hsnTableWidth * 0.20, halign: "right",fontStyle: "bold", fontSize: 7 };  // Total Amount
    }

    // Render HSN summary table
    doc.autoTable({
      startY: y,
      head: [hsnHeaders],
      body: hsnRows,
      theme: "grid",
      headStyles: {
        fillColor: "#e6f3ff",
        textColor: "#000000",
        fontSize: 7,
        fontStyle: "bold",
        valign: "middle",
        lineWidth: 0.3,
        halign: "center",
        lineColor: [0, 0, 0],
      },
      bodyStyles: {
        fontSize: 7,
        valign: "middle",
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
        halign: "right",
      },
      columnStyles: hsnColumnStyles,
      margin: { top: 0, left: margin-2.5, right: margin - 10  },
    });

    // Update y position after HSN table
    y = doc.autoTable.previous.finalY + 10;

    const addFooterSection = (footerSection) => {
      footerSection.forEach((section, index) => {
        const colStartX = margin + (index % 4) * sectionWidth;
        section.forEach((item, i) => {
          doc.setFontSize(item.size);
          doc.setFont(
            item.bold ? "helvetica" : "helvetica",
            item.bold ? "bold" : "normal"
          );
          doc.text(item.text, colStartX, y + i * 5);
        });
        if (index % 4 === 3) {
          y += 20;
        }
      });
      y += 25;
    };

    const addFooterWithSpaceCheck = (footerSection) => {
      const remainingSpace = pageHeight - y - margin;
      const requiredSpace = footerSection.length * 5 + 20;
      if (remainingSpace < requiredSpace) {
        doc.addPage();
        y = margin;
      }
      addFooterSection(footerSection);
      y += 10;
    };

    const cleanName = shopDetails.shop_name
      .replace(/\b(PVT\.?\s*LTD\.?|PRIVATE\s+LIMITED)\b/gi, '')
      .trim();
      
    const footerSections2 = [
      [
        {
          text: "Delivery Checked & Collected By : _ _ _ _ _ _ _ _ _",
          size: 8,
          bold: false,
        },
        {
          text: "Amt Paid :_ _ _ _ _ _ _ _ _ _Collected By :_ _ _ _ _ _ _ _ _ _ ",
          size: 8,
          bold: false,
        },
        { text: "Terms -", size: 8, bold: false },
        {
          text: `1 - Once delivery is received ${cleanName} is not responsible for any damage or loss `,
          size: 8,
          bold: false,
        },
        {
          text: `2 - Goods remain the property of ${cleanName} until invoice fully paid `,
          size: 8,
          bold: false,
        },
        {
          text: `3 - No claims for damages or short delivery will be considered unless made at the time of delivery of goods.`,
          size: 8,
          bold: false,
        },
        {
          text: `4 - There is No Refund Policy Of goods sold`,
          size: 8,
          bold: false,
        },
      ],
    ];

    addFooterWithSpaceCheck(footerSections2);

    const footerSections3 = [
      [
        { text: `Staff Note: ${orderDetails.staff_note}`, size: 8, bold: true },
        {
          text: `Note For Driver: ${orderDetails.note_for_driver}`,
          size: 8,
          bold: true,
        },
      ],
    ];

    addFooterWithSpaceCheck(footerSections3);

    const addPageNumbers = (doc) => {
      const pageCount = doc.internal.getNumberOfPages();
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();

      for (let i = 1; i <= pageCount; i++) {
        doc.setPage(i);
        doc.setFontSize(8);
        const pageNumberText = `Page ${i} of ${pageCount}`;
        const textWidth = doc.getTextWidth(pageNumberText);
        const xPosition = pageWidth - textWidth - 10;
        doc.text(pageNumberText, xPosition, pageHeight - 12);
      }
    };

    addPageNumbers(doc);
    const filename = generateUniqueFilename("Invoice", "pdf");
    doc.autoPrint();
    window.open(doc.output("bloburl"));
  } catch (error) {
    console.error("Error generating PDF:", error);
  }
};

export default generateSummaryPDF_rhv;